import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "lbp_admin_token";

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY) || "";
export const setAdminToken = (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);

export const adminClient = () =>
    axios.create({
        baseURL: API,
        headers: { Authorization: `Bearer ${getAdminToken()}` },
    });
